
import Header from "@/base/Header";
import Kicker from "@/base/Kicker";
import GenericPageBanner from "@/core/common/GenericPageBanner";
import FormPrivacyPolicy from './components/FormPrivacyPolicy';
import { css } from "@emotion/react";
import { rem } from "@util/convertUnits";
import { useEffect } from "react";
import RequestQuoteForm from "./components/RequestQuoteForm";
import HelmetBuilder from "@/base/HelmetBuilder";

const RequestQuoteFormPage = () => {


  const formCss = css(`
    width: 100%;
    max-width: ${rem(520)};
    margin-left: auto;
    margin-right: auto;
  `);

  // const frameStyle = css(`
  //   margin: 0 auto;
  //   display: block;
  // `)

  const buildMeta = () => {

    let data = {
      title: `Request a Quote | LaCantina Doors`,
      description: `Request a Quote`,
      keywords: 'BiFold Doors, Accordion, Folding Glass, Multi Slide, Swing Doors & Windows!',
    }

    return <HelmetBuilder data={data} preview={false} />
  }

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://jeldwen.tfaforms.net/js/iframe_resize_helper.js`;
    document.body.appendChild(script);
    return () => {
      script.parentNode.removeChild(script);
    }
  }, [])

  return (
    <div>
      {buildMeta()}
      <GenericPageBanner image="/images/banners/raq-banner.jpg" localImage={true}>
        <Kicker stylesOverride={{ textShadow: "0 0 1rem rgb(255,255,255)", color: '#000' }}>LaCantina Doors</Kicker>
        <Header tag="h1" style={{ textShadow: "0 0 1.5rem rgba(255,255,255,0.8)" }}>Request a Quote</Header>
      </GenericPageBanner>

      <div className="container m-gap">
        <RequestQuoteForm />
        {/* <iframe css={frameStyle} title="Request A Quote" src="https://jeldwen.tfaforms.net/7" height="800" width="600" frameBorder="0" ></iframe> */}
        <div css={formCss}>
          <FormPrivacyPolicy />
        </div>
      </div>
    </div>
  );
};
export default RequestQuoteFormPage;
